import axios from "axios";

//const API_URL = 'https://agifs.credisolve.co.za/api/';
//const API_URL = 'https://branch.credisolve.co.za/api/';
const API_URL = 'https://mmh.credisolve.co.za/api/';
//const API_URL = 'http://localhost:50463/';
axios.defaults.baseURL = API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.response.use(
    (a) => a,
    (error) => {
        if (!error.response) return Promise.reject({response: {data: 'Network Error'}});
        return Promise.reject(error);
    }
);


const CONTROLLER_PATH = "ContactDetails";
class ContactDetailsService {
    getContactDetails() {
        return axios.get(CONTROLLER_PATH ).then((response) => response.data);
    }
}

export default new ContactDetailsService();
